import { RefObject, useCallback, useEffect } from 'react';

type Props = {
    key: KeyboardEvent['key'];
    action: (e: KeyboardEvent) => void;
    mountTo?: RefObject<{
        addEventListener: (typeof window)['addEventListener'];
        removeEventListener: (typeof window)['removeEventListener'];
    } | null>;
    preventDefault?: boolean;
    deps?: unknown[];
};
export const useKeyDown = ({ key, action, preventDefault, mountTo, deps = [] }: Props) => {
    const onKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === key) {
                if (preventDefault) e.preventDefault();
                action(e);
            }
        },
        // eslint-disable-next-line react-hooks/use-memo
        [key, action, preventDefault, ...deps],
    );

    useEffect(() => {
        if (mountTo && !mountTo.current) return;

        (mountTo?.current || window).addEventListener('keydown', onKeyDown);
        return () => (mountTo?.current || window).removeEventListener('keydown', onKeyDown);
    }, [onKeyDown, mountTo]);

    return onKeyDown;
};
